import SvgColor from 'src/components/svgColor/SvgColor';

const icon = (name) => <SvgColor src={`/assets/icons/navbar/${name}.png`} sx={{ width: 1, height: 1 }} />;

const driverConfig = [
  {
    title: 'dashboard',
    path: '/',
    icon: icon('dash'),
  },

  {
    title: 'booking',
    path: '/booking',
    icon: icon('closed'),
  },
];

export default driverConfig;
